import timeout from '../service/inactivity-timeout-service';
import $ from 'jquery';
import { gsap } from "gsap";
 

class SignUpModalItem {
    constructor(el, i) {
        this.render(el,i)
    }

    toggleModal() {
        const body = document.querySelector('body')
        const modal = document.querySelector('.modal')
        //modal.classList.toggle('opacity-0')
        modal.classList.toggle('pointer-events-none')
        body.classList.toggle('modal-active')

        this.isOpen ? this.hideModal() : this.showModal();
        this.isOpen = !this.isOpen;
    }

    showModal() {

        var tl = new gsap.timeline();
        tl.set(this.overlay, { opacity: 0.0 });
        tl.set(this.el, {opacity: 1})
        tl.to(this.overlay, { opacity: 0.9, duration: 0.4, ease: "power3.out", delay: 0 });
        tl.fromTo(this.modal, { y: '20%', opacity: 0, scale:0.95 }, { opacity: 1, scale:1, y: 0, ease: "power3.out", duration: 0.2 });
    }

    hideModal() {
        var tl = new gsap.timeline();

        tl.to(this.modal, { opacity: 0, y: "20%", ease: "power3.out", scale: 0.95, duration: 0.2 });
        tl.to(this.overlay, { opacity: 0, duration: 0.4, ease: "power3.out" }, ">-0.2");
        tl.set(this.el, { opacity: 0})
    }

    document_KEYDOWN(e) {
        e = e || window.event
        var isEscape = false
        if ("key" in e) {
            isEscape = (e.key === "Escape" || e.key === "Esc")
        } else {
            isEscape = (e.keyCode === 27)
        }
        if (isEscape && document.body.classList.contains('modal-active')) {
            this.toggleModal()
        }
    }

    render(el, i) {

        this.isOpen = false;
        this.el = $(el);

        this.openmodal = document.querySelectorAll('[data-ref="open-signup-modal"]')

        for (var i = 0; i <this.openmodal.length; i++) {
            openmodal[i].addEventListener('click', function (event) {
                event.preventDefault()
                this.toggleModal()
            }.bind(this))
        }

        this.overlay = this.el.find('.modal-overlay');
        
        this.overlay.on('click', this.toggleModal)

        this.modal = this.el.find('.modal-container')
 

        var closemodal = document.querySelectorAll('[data-ref="close-signup-modal"]')
        for (var i = 0; i < closemodal.length; i++) {
            closemodal[i].addEventListener('click', this.toggleModal.bind(this))
        }

        timeout(1000 * 60 * 5, this.toggleModal.bind(this)); 

        $(document).on('keydown', this.document_KEYDOWN.bind(this));

    }
}



class SignUpModal {
    constructor(selector, element) {
        this.all = element.querySelectorAll(selector);
        for (var i = 0; i < this.all.length; i++) {
            this.render(this.all[i], i);
        }
    }

    render(el, index) {
      
       new SignUpModalItem(el, index);

    }
}


export default SignUpModal;